import * as React from 'react';
import { Field, Form } from 'formik';
import * as Yup from 'yup';
// TODO: This should be in a container and not in the component
import { navigate } from '~/router';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';


const LoginSchema = Yup.object().shape({
  username: Yup.string()
               .required('Required'),
  password: Yup.string()
               .required('Required'),
});


const LoginForm = ({ error, onSubmit, submitting }) => {
  const btnText = submitting ? 'Logging in...' : 'Login';

  const resetPassword = (e) => {
    e.preventDefault();
    navigate("reset");
  };

  return (
    <FormikForm
      initialValues={{
        username: '',
        password: '',
        data: '',
      }}
      onSubmit={(data) => onSubmit(LoginSchema.cast(data))}
      validationSchema={LoginSchema}
      render={(props) => {
        return (
          <Form className="form__cont form--login">
            <div className="form--login">
              <div className="logo__cont form--login__logo">
                <img src="/assets/img/placeholder/logo.svg" alt="" />
              </div>

              <Field name="username" label="Email Address" className="input input--lg" type="text" component={Input} />
              <Field name="password" label="Password" className="input input--lg" type="password" component={Input} />

              {error && <div className="form__note">{error}</div>}
              <button className="btn btn--secn btn--xlg fw" disabled={submitting} type="submit">
                {btnText}
              </button>

              <a className="btn btn--text" onClick={resetPassword}>
                Forgot Password?
              </a>
            </div>
          </Form>
        );
      }}
    />
  );
};

export default LoginForm;

